import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ranked-wines',
  templateUrl: './ranked-wines.component.html',
  styleUrls: ['./ranked-wines.component.scss']
})
export class RankedWinesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
